import { InjectionToken } from '@angular/core';
import { CommonsKeepAliveUtilsService } from 'ib-web-commons/app/core/ib-keep-alive/ib-keep-alive-utils-service';
import { upgradeAJSServiceProvider } from 'ib-web-commons/utils'; 
export const AJSGiftCardsCommonsKeepAliveUtilsService = new InjectionToken('CommonsKeepAliveUtilsService');
export const AJSGiftCardsCommonsKeepAliveUtilsServiceProvider = upgradeAJSServiceProvider('CommonsKeepAliveUtilsService', AJSGiftCardsCommonsKeepAliveUtilsService);
export interface GiftCardsCommonsKeepAliveUtilsServiceType extends CommonsKeepAliveUtilsService {
    initKeepAlive()
}
